import { Locales } from '@shared/models/enums/locale'
import { ILocalizedEntityType } from '@shared/models/proto/base/localized-entity'
import { getLastArrayItem } from '@shared/utils/helpers/array/get-last-array-item'
import getLocalizedLabel from '@shared/utils/helpers/localized-label'

export const getWelcomeMessage = (
  texts: ILocalizedEntityType[]
): ILocalizedEntityType =>
  getLocalizedLabel(texts, Locales.EnUS) ?? getLastArrayItem(texts)
